import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../data/stores/auth.store'
import { APP_ROUTES } from '../../constants/routes'

function AppLayout() {
  const { isAuthenticated } = useAuthStore()
  const nav = useNavigate()

  useEffect(() => {
    if (!isAuthenticated) {
      nav(APP_ROUTES.SignIn, { replace: true })
    }
  }, [isAuthenticated, nav])

  return (
    <main id="main" className="relative flex h-screen flex-col">
      <Outlet />
    </main>
  )
}

export default AppLayout
